import { action } from 'typesafe-actions';
import { OrderTypes, OrderType } from './types';

export const setOrder = (data: OrderType) => action(OrderTypes.SET, {data});
export const dropOrder = () => action(OrderTypes.DROP, {});
